export function createDate(y, M = 0, d = 1, h = 0, m = 0, s = 0, ms = 0) {
  const date = new Date(y, M, d, h, m, s, ms)
  if (y < 100 && y >= 0) {
    date.setFullYear(y)
  }
  return date
}

export function getCalendar({ firstDayOfWeek, year, month }) {
  const arr = []
  // change to the last day of the last month
  const calendar = createDate(year, month, 0)
  const lastDayInLastMonth = calendar.getDate()
  // getDay() 0 is Sunday, 1 is Monday
  const firstDayInLastMonth = lastDayInLastMonth - ((calendar.getDay() + 7 - firstDayOfWeek) % 7)
  for (let i = firstDayInLastMonth; i <= lastDayInLastMonth; i++) {
    arr.push(createDate(year, month, i - lastDayInLastMonth))
  }
  // change to the last day of the current month
  calendar.setMonth(month + 1, 0)
  const lastDayInCurrentMonth = calendar.getDate()
  for (let i = 1; i <= lastDayInCurrentMonth; i++) {
    arr.push(createDate(year, month, i))
  }

  const lastMonthLength = lastDayInLastMonth - firstDayInLastMonth + 1
  const nextMonthLength = 6 * 7 - lastMonthLength - lastDayInCurrentMonth
  for (let i = 1; i <= nextMonthLength; i++) {
    arr.push(createDate(year, month, lastDayInCurrentMonth + i))
  }
  return arr
}

export function startOfYear(value) {
  const date = new Date(value)
  date.setMonth(0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}
export function startOfMonth(value) {
  const date = new Date(value)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}
export function startOfDay(value) {
  const date = new Date(value)
  date.setHours(0, 0, 0, 0)
  return date
}
export function setMonth(dirtyDate, dirtyMonth) {
  const date = new Date(dirtyDate)
  const month = typeof dirtyMonth === 'function' ? dirtyMonth(date.getMonth()) : Number(dirtyMonth)
  const year = date.getFullYear()
  const daysInMonth = createDate(year, month + 1, 0).getDate()
  const day = date.getDate()
  date.setMonth(month, Math.min(day, daysInMonth))
  return date
}

export function setYear(dirtyDate, dirtyYear) {
  const date = new Date(dirtyDate)
  const year = typeof dirtyYear === 'function' ? dirtyYear(date.getFullYear()) : dirtyYear
  date.setFullYear(year)
  return date
}



export function isValidRangeDate(date) {
  return Array.isArray(date) && date.length === 2 && date.every(isValidDate) && date[0] <= date[1]
}
export function isValidDates(dates) {
  return Array.isArray(dates) && dates.every(isValidDate)
}
export function isValidDate(date) {
  return date instanceof Date && !isNaN(date)
}
export function getValidDate(value, ...backup) {
  const date = new Date(value)
  if (isValidDate(date)) {
    return date
  }
  if (backup.length) {
    return getValidDate(...backup)
  }
  return new Date()
}
export function assignTime(target, source) {
  const date = new Date(target)
  const time = new Date(source)
  date.setHours(time.getHours(), time.getMinutes(), time.getSeconds())
  return date
}





/**
 * chunk the array
 * @param {Array} arr
 * @param {Number} size
 */
export function chunk(arr, size) {
  if (!Array.isArray(arr)) {
    return []
  }
  const result = []
  const len = arr.length
  let i = 0
  size = size || len
  while (i < len) {
    result.push(arr.slice(i, (i += size)))
  }
  return result
}
/**
 * isObject
 * @param {*} obj
 * @returns {Boolean}
 */
export function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}
/**
 * deep merge two object without merging array
 * @param {object} target
 * @param {object} source
 */
export function mergeDeep(target, source) {
  if (!isObject(target)) {
    return {}
  }
  let result = target
  if (isObject(source)) {
    Object.keys(source).forEach(key => {
      let value = source[key]
      if (isObject(value) && isObject(target[key])) {
        value = mergeDeep(target[key], value)
      }
      result = { ...result, [key]: value }
    })
  }
  return result
}
/**
 * pick object
 * @param {Object} obj
 * @param {Array|String} props
 */
export function pick(obj, props) {
  if (!isObject(obj)) { return {} }
  if (!Array.isArray(props)) {
    props = [props]
  }
  const res = {}
  props.forEach(prop => {
    if (prop in obj) {
      res[prop] = obj[prop]
    }
  })
  return res
}


export function format(date, fmt, locale) {
  // Преобразуем timestamp или строку в Date
  if (!(date instanceof Date)) {
    date = new Date(date)
  }
  if (!(date instanceof Date) || isNaN(date)) { return '' }
  const pad = (n) => n < 10 ? '0' + n : n
  const monthsShort = locale.formatLocale?.monthsShort
  const monthsLong = locale.formatLocale?.months
  const weekdaysMin = locale.formatLocale?.weekdaysMin
  const weekdaysShort = locale.formatLocale?.weekdaysShort || weekdaysMin
  const weekdaysLong = locale.formatLocale?.weekdays
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  const weekday = date.getDay()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()
  const ms = date.getMilliseconds()
  // ISO week number
  const getWeek = (d) => {
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1))
    return Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
  }
  // Timezone offset
  const tzOffset = -date.getTimezoneOffset()
  const sign = tzOffset >= 0 ? '+' : '-'
  const tzH = pad(Math.floor(Math.abs(tzOffset) / 60))
  const tzM = pad(Math.abs(tzOffset) % 60)
  // Meridiem
  const meridiem = hours < 12 ? 'AM' : 'PM'
  const meridiemLower = meridiem.toLowerCase()
  // Unix timestamp
  const unix = Math.floor(date.getTime() / 1000)
  // Milliseconds timestamp
  const unixMs = date.getTime()

  let str = fmt
  str = str.replace(/YYYY/g, year)
  str = str.replace(/YY/g, String(year).slice(-2))
  str = str.replace(/MMMM/g, monthsLong?.[month])
  str = str.replace(/MMM/g, monthsShort?.[month])
  str = str.replace(/MM/g, pad(month + 1))
  str = str.replace(/M/g, month + 1)
  str = str.replace(/DD/g, pad(day))
  str = str.replace(/D/g, day)
  str = str.replace(/dddd/g, weekdaysLong?.[weekday])
  str = str.replace(/ddd/g, weekdaysShort?.[weekday])
  str = str.replace(/dd/g, weekdaysMin?.[weekday])
  str = str.replace(/d/g, weekday)
  // Week tokens
  str = str.replace(/ww/g, pad(getWeek(date)))
  str = str.replace(/w/g, getWeek(date))
  // Time tokens
  str = str.replace(/HH/g, pad(hours))
  str = str.replace(/H/g, hours)
  str = str.replace(/hh/g, pad(hours % 12 || 12))
  str = str.replace(/h/g, hours % 12 || 12)
  str = str.replace(/mm/g, pad(minutes))
  str = str.replace(/m/g, minutes)
  str = str.replace(/ss/g, pad(seconds))
  str = str.replace(/s/g, seconds)
  str = str.replace(/SSS/g, String(ms).padStart(3, '0'))
  str = str.replace(/SS/g, String(ms).padStart(3, '0').slice(0, 2))
  str = str.replace(/S/g, String(ms).padStart(3, '0').slice(0, 1))
  // Meridiem
  str = str.replace(/A/g, meridiem)
  str = str.replace(/a/g, meridiemLower)
  // Timezone
  str = str.replace(/ZZ/g, `${sign}${tzH}${tzM}`)
  str = str.replace(/Z/g, `${sign}${tzH}:${tzM}`)
  // Unix timestamp
  str = str.replace(/X/g, unix)
  str = str.replace(/x/g, unixMs)
  // Day of month (1-31)
  str = str.replace(/b/g, pad(day))
  return str
}